var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"e-chat-icon"},[_c('IconChat'),(_vm.showNotification)?_c('el-tooltip',{attrs:{"content":_vm.notificationMessage,"effect":"dark","placement":"top"}},[_c('div',{staticClass:"e-badge e-badge--chat-icon"})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }